import { CSVImporter } from 'csv-import-react';
import Modal from '../Modal';
import { useState } from 'react';
import Loading from '../Loading';
import FileImportModal from '../FileImportModal.jsx';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import * as Toast from '../../lib/Toast.js';
import { useCustomFieldsSchemaQuery } from '~/lib/Queries';
import { ObjectTypes } from '~/lib/ObjectTypes';

const ImportClientsModal = ({ isOpen, onClose, onSuccess }) => {
    const { save, isSaving } = useBusinessPostApi(`/import/clients`);
    const { data: customFieldData, isLoading: isLoadingCustomFields } =
        useCustomFieldsSchemaQuery(ObjectTypes.CLIENT);

    function doSave(data) {
        return save({ rows: data }).then(result => {
            Toast.success(
                `Successfully imported ${result.count} clients${result.skipped > 0 ? `, skipped ${result.skipped} because they were missing an email or already in your client list` : ''}`,
            );
            onSuccess();
        });
    }

    let customFieldColumns = [];
    if (customFieldData) {
        customFieldData.forEach(field => {
            customFieldColumns.push({
                name: field.schema?.label || 'Custom Field',
                key: `custom-${field.key}`,
                required: false,
            });
        });
    }

    return (
        <FileImportModal
            isOpen={isOpen}
            onClose={onClose}
            doSave={doSave}
            title="Import Clients"
            template={{
                columns: [
                    {
                        name: 'First Name',
                        key: 'first_name',
                        required: false,
                        suggested_mappings: ['First'],
                    },
                    {
                        name: 'Last Name',
                        key: 'last_name',
                        required: false,
                        suggested_mappings: ['Last'],
                    },
                    {
                        name: 'Email',
                        key: 'email',
                        required: true,
                        suggested_mappings: ['Email', 'E-mail'],
                    },
                    {
                        name: 'Phone',
                        key: 'phone',
                        required: false,
                        suggested_mappings: ['Phone'],
                    },
                    {
                        name: 'Notes',
                        key: 'notes',
                        required: false,
                        suggested_mappings: ['Note'],
                    },
                    ...customFieldColumns,
                ],
            }}
        />
    );
};

export default ImportClientsModal;
